import React, { FC, ReactNode } from 'react';
import cls from 'classnames';

import styles from './index.module.sass';

interface ILinkProps {
  children?: ReactNode;
  className?: string;
  href: string;
}

export const Link: FC<ILinkProps> = ({ children, className, href }) => (
  <a className={cls( styles.link, className )} href={href}>
    {children}
  </a>
);
